<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <z-popup v-model="showPopup" position="center" class="tipPopup" :close-on-click-overlay="false">
      <header class="tip-header">重复问题提醒</header>
      <p class="tip-content">{{feedBackMsg}}</p>
      <section class="popup-content">
        <div class="service-section">
          <order-service-section
            v-if="feedBackStatus !== '2'"
            :orderId="orderId"
            :faqId="faqId"
            :showPopup="showPopup"
          >
          </order-service-section>
          <div class="feedback-btn">
            <z-button v-if="feedBackStatus !== '2'" :text="processBtnText" @click="jumpToProcessList"/>
            <z-button :text="btnText" type="primary" @click="handleNext"/>
          </div>
        </div>
      </section>
    </z-popup>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { Button, Popup } from '@zz-common/zz-ui'
import OrderServiceSection from '../OrderServiceSection'
export default {
  name: 'TippopupNew',
  data() {
    return {
      processBtnText: '查看进度'
    }
  },
  props: {
    feedBackStatus: {
      type: String
    },
    feedBackMsg: {
      type: String,
      default: ''
    },
    showPopup: {
      type: Boolean,
      default: false
    },
    isNew: {
      type: Boolean,
      default: true
    },
    // 已选的订单id
    orderId: {
      type: String
    },
    // 当前已选的问题分类id
    faqId: {
      type: String
    }
  },
  components: {
    'z-button': Button,
    'z-popup': Popup,
    OrderServiceSection
  },
  computed: {
    btnText() {
      let btnText = ''
      switch (this.feedBackStatus) {
        case '0': btnText = this.isNew ? '继续反馈' : '继续填写'; break
        case '1': btnText = '退出'; break
        case '2': btnText = '安全中心'; break
      }
      return btnText
    }
  },
  methods: {
    // 跳转至风控
    handleNext() {
      if (this.feedBackStatus == 2) {
        native.skipToUrl({
          targetUrl: 'https://feentry.zhuanzhuan.com/SafeCenter?clientid=SafeCenterHome',
          needClose: '1'
        })
      } else if (this.feedBackStatus == 0) {
        this.$emit('togglePopup', false)
      } else { // 不可建单
        native.close()
      }
    },
    // 跳转至服务单详情
    jumpToProcessList() {
      lego.send({
        pagetype: 'ZZKF_CENTER_ORDER_SERVICE',
        actiontype: 'JUMP_LIST'
      })
      // 兼容ios返回手势动作，如果使用push则会直接返回到“我的”
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/serviceprocess/list'
      })
    }
  }
}

</script>
<style lang="less" scoped>
  @import './index.less';
</style>
